// extracted by mini-css-extract-plugin
module.exports = {"entryItemCard":"company-detail-press-release_component_entryItemCard__0zumv","cardTitle":"company-detail-press-release_component_cardTitle__jd95_"};